/**
 * Class to implement a Journey of dependent campaigns
 * This will be instantiated by developers and passed on to the CampaignUnit as props
 */
class Journey {
    constructor(private run: () => void, private started: boolean = false) {}

    start() {
        if (this.started) {
            return;
        }
        this.started = true;
        this.run();
    }
}

export default Journey;
